// xlsx 行21 の 4値 (先方確認中/修正対応中/保留/締結済) を既存セットに包含
const CONTRACT_STATUS_OPTIONS = [
  { value: 'sender_review', label: '先方確認中' },
  { value: 'revising', label: '修正対応中' },
  { value: 'reviewing', label: '社内法務確認中' },
  { value: 'preparing', label: '準備中' },
  { value: 'sent', label: '送付済み' },
  { value: 'on_hold', label: '保留' },
  { value: 'signed', label: '締結済み' },
  { value: 'expired', label: '期限切れ' },
  { value: 'terminated', label: '解除済み' },
  { value: 'renewing', label: '更新確認中' },
  { value: 'renewed', label: '更新済み' },
];

export default CONTRACT_STATUS_OPTIONS;
